<a href="{{url}}" *ngIf="text; else emptyText">{{text}}</a>
<ng-template #emptyText>{{text | stringFormat}}</ng-template>
